import { createAction, props } from '@ngrx/store';
import { Color } from '../../../api/models/color.model';


export const loadCCTColors = createAction(
    '[CCT Colors] Load CCT Colors for selected Account via service',
    props<{ cctColorsForAccount: number }>()
)

export const setCCTColors = createAction(
    '[CCT Colors] Set CCT Colors for selected Account via service Success',
    props<{ cctColors: Color[] }>()
)

export const setCCTColorsFail = createAction(
    '[CCT Colors] Set CCT Colors for selected Account via service Failed',
    props<{ error: any }>()
)

export const add = createAction(
    '[CCT Color] Add CCT Colors for selected Account via service Success',
    props<{ color: Color }>()
)

export const deleteCCT = createAction(
    '[CCT Color] Delete CCT Colors for selected Account via service Success',
    props<{ id: number }>()
)

export const clear = createAction(
    '[CCT Color] Clear all colors'
);

export const cctcolorActionTypes = {

    loadCCTColors,
    setCCTColors,
    setCCTColorsFail,
    add,
    deleteCCT,
    clear
};
